import React from 'react';

import {
  Actions,
  Action,
  CreditCardIcon,
  UploadFileIcon,
  BlockIcon,
  DownloadIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

export const InvoiceActions = ({
  actions,
  onUndo,
  onMarkAsPaid,
  onExport,
  onReplaceFile,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <Actions>
          <Action
            id={'mark_paid'}
            icon={<CreditCardIcon />}
            label={'Mark as Paid'}
            disabled={!isActionAllowed('markPaid')}
            onClick={onMarkAsPaid}
          />
          <Action
            id={'cancel_payment'}
            icon={<BlockIcon />}
            label={'Block'}
            disabled={!isActionAllowed('cancelPayment')}
            onClick={onUndo}
          />
          <Action
            id={'replace_attachment'}
            icon={<UploadFileIcon />}
            label={'Replace'}
            disabled={!isActionAllowed('replaceAttachment')}
            onClick={onReplaceFile}
          />
          <Action
            id={'export'}
            icon={<DownloadIcon />}
            label={'Export'}
            onClick={onExport}
          />
        </Actions>
      )}
    </Permissions>
  );
};
export default InvoiceActions;
